import type { Preset } from '../../gql';

import { randNumber, randPastDate, randUuid, randProduct } from '@ngneat/falso';

import { mockPresetUsage } from './mockPresetUsage';

const mockPreset = (overwrite?: Partial<Preset>): Preset => ({
    presetPublicId: randUuid(),
    presetName: randProduct().title + ' preset (mock)',
    createdBy: randUuid(),
    createdDate: randPastDate(),
    presetUsages: Array.from({ length: randNumber({ min: 1, max: 6 }) }, () =>
        mockPresetUsage()
    ),
    ...overwrite,
});

export { mockPreset };
